export { ClinicalHistoryEarlyStageContainer } from './clinical-history-early-stage-container';
